import { render, staticRenderFns } from "./ReportsScreen.vue?vue&type=template&id=d12a4a58&scoped=true&"
import script from "./ReportsScreen.vue?vue&type=script&lang=js&"
export * from "./ReportsScreen.vue?vue&type=script&lang=js&"
import style0 from "./ReportsScreen.vue?vue&type=style&index=0&id=d12a4a58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12a4a58",
  null
  
)

export default component.exports